export default __webpack_public_path__ + "static/media/icon_xls.3cfe98c7.svg";